import { IWhiteLabel } from '@efex-services/auth/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ORGANIZATION_ID, ORGANIZATION_LOG_URL } from '../constants';

const initialState: IWhiteLabel = {
  [ORGANIZATION_ID]: undefined,
  [ORGANIZATION_LOG_URL]: undefined,
};

const whiteLabelSlice = createSlice({
  name: 'whiteLabel',
  initialState,
  reducers: {
    setWhiteLabel: (state, action: PayloadAction<IWhiteLabel>) => {
      state.organizationID = action.payload.organizationID;
      state.organizationLogoURL = action.payload.organizationLogoURL;
      state.providerCode = action.payload.providerCode;
    },
    reset: () => initialState,
  },
});

export const { setWhiteLabel, reset } = whiteLabelSlice.actions;

export default whiteLabelSlice.reducer;
